import useSWR from 'swr';
import { listChatSessionsApi } from 'src/api/chat/Chat';
import type { ChatSession } from '@/types/chat.types';
import { ChatScope } from '@/types/chat.types';

export interface ChatSessionSummary {
  id: string;
  title: string;
  firstAt: string;
  lastAt: string;
  messageCount: number;
}

const fetcher = async (): Promise<ChatSessionSummary[]> => {
  const response = await listChatSessionsApi({ limit: 50 });
  return response.sessions.map((s) => ({
    id: s.chatSessionId,
    title: s.title,
    firstAt: s.firstAt,
    lastAt: s.lastAt,
    messageCount: s.messageCount,
  }));
};

export function useChatSessions(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR(
    enabled ? ['chat-sessions'] : null,
    fetcher,
  );

  const sessions = data ?? [];

  return { sessions, isLoading, error, mutate };
}
